"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = absoluteCenter;
function absoluteCenter() {
  return /*css*/"\n    position: absolute;\n    margin: auto;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n  ";
}